// prettier-ignore
export default "b64"